export const features = [
    {
        id: '0',
        icon: '/images/feature-1.png',
        caption: 'Unlock the Power of AI',
        title: 'Intelligent AI Chatbot',
        text: 'Engage with Wall-E’s AI chatbot for personalized assistance. Whether its answering questions or offering valuable insights, our chatbot adapts to your needs seamlessly.',
    },
    {
        id: '1',
        icon: '/images/feature-2.png',
        caption: 'Access Cutting-Edge Tools',
        title: 'AI-Powered Tools',
        text: 'With over 15 AI-powered tools at your fingertips, Wall-E helps you tackle various tasks, from image generation to code writing, all designed to boost your productivity.',
    },
];



export const faq = [
    {
        id: '0',
        question: 'What is Wall-E?',
        answer: 'Wall-E is a platform offering 15+ AI tools designed to help you with tasks like content creation, image generation, text enhancement, and more. All tools are designed to boost your productivity.'
    },
    {
        id: '1',
        question: 'How do I access the AI tools?',
        answer: 'Simply sign up for a free account on Wall-E, and you’ll have instant access to all of our AI tools. Start using them right away!'
    },
    {
        id: '2',
        question: 'What types of tools are available?',
        answer: 'We offer a wide range of AI tools, including a chatbot for conversations, an image generator, text summarizer, and more. Check out the dashboard after logging in to see the full list of tools.'
    },
    {
        id: '3',
        question: 'Can I use Wall-E on my mobile device?',
        answer: 'Yes! Wall-E is fully responsive and works seamlessly on both mobile devices and desktops, so you can access all the tools on the go.'
    },
    {
        id: '4',
        question: 'Is Wall-E free to use?',
        answer: 'Yes, Wall-E is currently free to use as we are in the beta phase. We plan to enhance the platform and add more features in the future.'
    },
    {
        id: '5',
        question: 'How to create an account on Wall-E?',
        answer: 'To create an account, simply visit the Wall-E website and click on "Try it Now".Provide your basic information, and you will have immediate access to all the available tools.'
    },
    {
        id: '6',
        question: 'Can I access Wall-E tools without an account?',
        answer: 'No, you need to create an account to access Wall-E’s AI tools. It’s quick, free, and gives you full access to all the tools available.'
    },
    {
        id: '7',
        question: 'How will Wall-E improve in the future?',
        answer: 'We’re actively working on expanding the available tools, improving the user experience, and adding more features to enhance your productivity. Stay tuned for regular updates!'
    }
];

export const steps=[
    {
        name:"Step-1",
        desc:"Sign Up for Free",
        text:"Create your Wall-E account at no cost to unlock 15+ powerful AI tools tailored to boost your productivity."
    },
    {
        name:"Step-2",
        desc:"Access AI Tools",
        text:"Explore a variety of AI-powered tools such as image generation and much more, all in one place."
    },
    {
        name:"Step-3",
        desc:"Boost Your Productivity",
        text:"Start using the AI tools instantly to enhance your work, streamline tasks, and get things done faster!"
    }
];



export const template=[
    {
        name: 'LinkedIn Post Generator',
        desc: 'Generate engaging LinkedIn posts that are optimized for professional networking, showcasing insights, and reaching a wider audience.',
        category: 'Social Media',
        icon: 'https://cdn-icons-png.flaticon.com/128/174/174857.png', 
        slug: 'linkedin-post-generator',
        aiPrompt: 'Generate a LinkedIn post based on the provided topic and outline, formatted for readability and engagement in a professional tone',
        form: [
            {
                label: 'Enter post topic',
                field: 'input',
                name: 'topic',
                required: true
            },
            {
                label: 'Enter post outline or key points',
                field: 'textarea',
                name: 'outline',
                required: true
            },
        ]
    },    
    {
        name: 'English Grammar Checker',
        desc: 'An AI model designed to enhance your English grammar by analyzing and correcting your text for clarity and accuracy.',
        icon:'https://cdn-icons-png.flaticon.com/128/12596/12596700.png',
        category: 'english',
       
        slug: 'english-grammer-checker',
        aiPrompt: 'Give the Output in Standard english and make it more attractive and give output in  in rich text editor format',
        form: [
            {
                label: 'Enter text to correct the grammer',
                field: 'input',
                name: 'inputText',
                required:true
            },
           
        ]
    },
    {
        name: 'Code Writer',
        desc: 'An AI model that generates programming code in any language, helping you quickly create efficient and effective solutions for your projects.',
        icon:'https://cdn-icons-png.flaticon.com/128/6062/6062646.png',
        category: 'Coding',
        slug: 'write-code',
        aiPrompt: 'Depends on user codeDescription write a code and give output in  in rich text editor format in code block ',
        form: [
            {
                label: 'Enter description of code you want along with Programming Language',
                field: 'textarea',
                name: 'codeDesscripton',
                required:true
            },
           
        ]
    },
    {
        name: 'Explain Code',
        desc: 'An AI model that explains programming code in any language, providing clear and concise explanations to enhance your understanding and improve your coding skills.',
        icon:'https://cdn-icons-png.flaticon.com/128/8488/8488751.png',
        category: 'Coding',
       
        slug: 'explain-code',
        aiPrompt: 'Depends on user codeDescription explain code line by line and give output in  in rich text editor format in code block ',
        form: [
            {
                label: 'Enter code which you want to understand',
                field: 'textarea',
                name: 'codeDesscripton',
                required:true
            },
           
        ]
    },
    {
        name: 'Code Bug Detector',
        desc: 'This innovative tool analyzes your input, including error messages and code snippets, to quickly identify and fix bugs. It provides clear, detailed solutions and alternatives, all in a user-friendly format to enhance your coding experience!',
        icon:'https://cdn-icons-png.flaticon.com/128/4426/4426267.png',
        category: 'code-bug-detector',
       
        slug: 'code-bug-detector',
        aiPrompt: 'Depends on user codeInput find bug in code and give solution and give output in  in rich text editor format in code block ',
        form: [
            {
                label: 'Enter code which you want to test bug',
                field: 'textarea',
                name: 'codeInput',
                required:true
            },
           
        ]
    },
    {
        name: 'Tagline Generator',
        desc: 'Struggling to find the perfect tagline for your brand? Let our AI-tool assist you in creating a tagline that stands out.',
        icon:'https://cdn-icons-png.flaticon.com/128/2178/2178616.png',
        category: 'Marketting',
       
        slug: 'tagline-generator',
        aiPrompt: 'Depends on user productName and outline generate catchy 5-10 tagline for the business product and give output  in rich text editor format ',
        form: [
            {
                label: 'Product/Brand Name',
                field: 'input',
                name: 'productName',
                required:true
            },
            {
                label: 'What you are selling / Marketting',
                field: 'textarea',
                name: 'outline',
                required:true
            },
           
        ]
    },
    {
        name: 'Product Description',
        desc: 'This is your AI-powered SEO expert, creating captivating and keyword-rich e-commerce product descriptions to boost your online sales.',
        icon:'https://cdn-icons-png.flaticon.com/128/679/679922.png',
        category: 'Marketting',
       
        slug: 'product-description',
        aiPrompt: 'Depends on user productName and description generate small description for product for e-commer business give output  in rich text editor format  ',
        form: [
            {
                label: 'Product Name',
                field: 'input',
                name: 'productName',
                required:true
            },
            {
                label: 'Product Details',
                field: 'textarea',
                name: 'outline',
                required:true
            },
           
        ]
    },
    {
        name:'Blog Title',
        desc:'A smart AI tool that generates engaging blog titles based on your content. Just enter your blog info, and get titles designed to capture readers attention.',
        category:'Blog',
        icon:'https://cdn-icons-png.flaticon.com/128/4186/4186534.png',
        aiPrompt:'Give me 5 blog topic idea in bullet wise only based on give niche & outline and give me result in Rich text editor format',
        slug:'generate-blog-title',
        form:[
            {
                label:'Enter your blog niche',
                field:'input',
                name:'niche',
                required:true
            },
            {
                label:'Enter blog outline',
                field:'textarea',
                name:'outline',
                
            }
        ]
    },
    {
        name: 'Blog Content',
        desc: 'An AI-powered tool that acts as your personal blog title generator, creating catchy, viral-ready titles in any language you choose.',
        category: 'blog',
        icon: 'https://cdn-icons-png.flaticon.com/128/4905/4905454.png',
        slug: 'blog-content-generation',
        aiPrompt: 'Generate Blog Content based on topic and outline in rich text editor format',
        form: [
            {
                label: 'Enter your blog topic',
                field: 'input',
                name: 'topic',
                required:true
            },
            {
                label: 'Enter blog Outline here',
                field: 'textarea',
                name: 'outline'
            }
        ]
    },
    {
        name: 'Blog Topic Ideas',
        desc: 'An AI tool that crafts engaging and viral-ready blog titles tailored to your content, available in your preferred language.',
        category: 'Blog',
        icon: 'https://cdn-icons-png.flaticon.com/128/11497/11497847.png',
        slug: 'blog-topic-idea',
        aiPrompt: 'Generate top 5 Blog Topic Ideas in bullet point only, (no Description) based on niche in rich text editor format',
        form: [
            {
                label: 'Enter your Niche',
                field: 'input',
                name: 'niche',
                required:true
            },
        ]
    },
    {
        name: 'Youtube SEO Title',
        desc: 'An AI-powered tool designed to create attention-grabbing, viral-ready blog titles for you, available in any language you choose.',
        category: 'Youtube Tools',
        icon: 'https://cdn-icons-png.flaticon.com/128/402/402075.png',
        slug: 'youtube-seo-title',
        aiPrompt: 'Give me Best SEO optimized high ranked 5 title ideas bullet wise only bases on keywords and outline and give me result in rich text editor format',
        form: [
            {
                label: 'Enter your youtube video topic keywords',
                field: 'input',
                name: 'keywords',
                required:true
            },
            {
                label: 'Enter youtube description Outline here',
                field: 'textarea',
                name: 'outline'
            }
        ]

    },
    {

        name: 'Youtube Description',
        desc: 'An AI tool that serves as your personal blog post title writer, generating catchy and viral-worthy titles in your chosen language.',
        category: 'Youtube Tool',
        icon: 'https://cdn-icons-png.flaticon.com/128/2111/2111748.png',
        slug: 'youtube-description',
        aiPrompt: 'Generate Youtube description with emoji under 4-5 lines based on topic and outline in rich text editor format',
        form: [
            {
                label: 'Enter your blog topic/title',
                field: 'input',
                name: 'topic',
                required:true
            },
            {
                label: 'Enter youtube Outline here',
                field: 'textarea',
                name: 'outline'
            }
        ]
    },
    {
        name: 'Youtube Tags',
        desc: 'An AI tool that serves as your personal blog post title writer, generating catchy and viral-worthy titles in your chosen language.',
        category: 'Youtube Tool',
        icon: 'https://cdn-icons-png.flaticon.com/128/4674/4674918.png',
        slug: 'youtube-tag',

        aiPrompt: 'Generate 10 Youtube tags in bullet point based on title and outline in rich text editor format',

        form: [
            {
                label: 'Enter your youtube title',
                field: 'input',
                name: 'title',
                required:true
            },
            {
                label: 'Enter youtube video Outline here (Optional)',
                field: 'textarea',
                name: 'outline'
            }
        ]
    },

    {
        name: 'Rewrite Article (Plagiarism Free)',
        desc: 'Use this tool to rewrite existing Article or Blog Post which can bypass AI detectors and also make it plagiarism free.',
        icon: 'https://cdn-icons-png.flaticon.com/128/3131/3131607.png',
        category: 'Rewriting Tool',
        slug: 'rewrite-article',
        aiPrompt: 'Rewrite give article without any Plagiarism in rich text editor format',
        form: [
            {
                label: '🤖 Provide your Article/Blogpost or any other content to rewrite.',
                field: 'textarea',
                name: 'article',
                required:true
            }
        ]
    },
    {
        name: 'Text Improver',
        desc: 'This handy tool refines your writing, eliminating errors and redundancies for a clear, readable result. It also offers a comprehensive tone analysis and suggests better word choices.',
        icon: 'https://cdn-icons-png.flaticon.com/128/1686/1686815.png',
        category: 'Writing Assistant',
        slug: 'text-improver',
        aiPrompt: 'Given textToImprove, Rewrite text without any grammar mistake and professionally in rich text editor format',
        form: [
            {
                label: 'Enter text that you want to re-write or improve',
                field: 'textarea',
                name: 'textToImprove'
            }
        ]
    },
    {
        name: 'Add Emojis to Text',
        desc: 'An AI tool that serves as your personal blog post title writer, generating catchy and viral-worthy titles in your chosen language.',
        icon: 'https://cdn-icons-png.flaticon.com/128/2584/2584606.png',
        category: 'blog',
        slug: 'add-emoji-to-text',
        aiPrompt: 'Add Emoji to outline text depends on outline and rewrite it in rich text editor format',
        form: [
            {
                label: 'Enter your text to add emojis',
                field: 'textarea',
                name: 'outline',
                required:true
            }
        ]
    },
    {
        name: 'Instagram Post Generator',
        desc: 'An AI tool that serves as your personal blog post title writer, generating catchy and viral-worthy titles in your chosen language.',
        icon: 'https://cdn-icons-png.flaticon.com/128/15713/15713420.png',
        category: 'blog',
       
        slug: 'instagram-post-generator',
        aiPrompt: 'Generate 3 Instagram post depends on a given keywords and give output in  in rich text editor format',
        form: [
            {
                label: 'Enter Keywords for your post',
                field: 'input',
                name: 'keywords',
                required:true
            },
           
        ]
    },
    {
        name: 'Instagram Hash Tag Generator',
        desc: 'An AI tool that serves as your personal blog post title writer, generating catchy and viral-worthy titles in your chosen language.',
        icon: 'https://cdn-icons-png.flaticon.com/128/7045/7045432.png',
        category: 'blog',
       
        slug: 'instagram-hash-tag-generator',
        aiPrompt: 'Generate 15 Instagram hash tag depends on a given keywords and give output in rich text editor format',
        form: [
            {
                label: 'Enter Keywords for your instagram hastag',
                field: 'input',
                name: 'keywords',
                required:true
            },
           
        ]
    },
    {
        name: 'Instagram Post/Reel Idea',
        desc: 'An AI tool that generates fresh, trending Instagram content ideas tailored to your niche. Perfect for keeping your posts engaging and relevant!',
        icon: 'https://cdn-icons-png.flaticon.com/128/1029/1029183.png',
        category: 'instagram',
       
        slug: 'instagram-post-idea-generator',
        aiPrompt: 'Generate 5-10 Instagram idea depends on niche with latest trend and give output in rich text editor format',
        form: [
            {
                label: 'Enter Keywords / Niche for your instagram idea',
                field: 'input',
                name: 'keywords',
                required:true
            },
           
        ]
    },

];